import { Flex } from 'antd'

import { AccountAuthenticationPanel } from '../pages/AccountAuthenticationPage'
import { AccountSecurityPanel } from '../pages/AccountSecurityPage'

/**
 * Security tab — merges the former Authentication and Security sub-pages into a
 * single scroll: sign-in methods, MFA and sign-in policy first, then the
 * security center (passkeys, recovery codes, trusted devices, password).
 */
export const SecurityTab = () => (
  <Flex vertical gap={16}>
    <AccountAuthenticationPanel />
    <AccountSecurityPanel />
  </Flex>
)
